import clsx from "clsx";
import styles from "./index.module.scss";

export default function Tooltip({ children, customStyles }) {
  return <div className={clsx(styles.Tooltip, customStyles)}>{children}</div>;
}
